import {GlobalVariables} from "../GlobalVariables";

export default class BlockNews {
	static init() {

		let blocks = document.querySelectorAll('.block-news');

		blocks.forEach( (block) => {
			const swiper = block.querySelector('.swiper');
			const prev = block.querySelector(".swiper-custom-button-prev");
			const next = block.querySelector(".swiper-custom-button-next");
			const navigationContainer = block.querySelector(".swiper-custom-navigation-container");
			let swiperElement = new Swiper(swiper, {
				slidesPerView: "auto",
				grabCursor: true,
				spaceBetween: 20,
				speed: 600,
				breakpoints: {
					768: {
						slidesPerView: 3,
						slidesPerGroup: 3
					}
				},
				navigation: {
					prevEl: prev,
					nextEl: next
				},
				on: {
					resize: function () {
						const isPrevDisabled = swiperElement.navigation.prevEl.classList.contains('swiper-button-disabled');
						const isNextDisabled = swiperElement.navigation.nextEl.classList.contains('swiper-button-disabled');
						navigationContainer.classList.toggle('d-none', isPrevDisabled && isNextDisabled);
					}
				}
			});
		});

	}

}
